import { useEffect, useState } from 'react';

const useLastSavedLabel = (lastSavedAt, translate) => {
    const [, setNow] = useState(Date.now());

    useEffect(() => {
        if (!lastSavedAt) return undefined;
        const interval = setInterval(() => setNow(Date.now()), 60000);
        return () => clearInterval(interval);
    }, [lastSavedAt]);

    if (!lastSavedAt) return '';

    const now = new Date();
    const savedAt = new Date(lastSavedAt);
    const minutes = Math.floor((now - savedAt) / 60000);
    const isSameDay =
        now.getFullYear() === savedAt.getFullYear() &&
        now.getMonth() === savedAt.getMonth() &&
        now.getDate() === savedAt.getDate();

    if (!isSameDay) {
        return translate('autosave.date', 'Last saved on {{date}}', {
            date: new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(savedAt),
        });
    }
    if (minutes <= 0) return translate('autosave.just-now', 'Last saved just now');
    if (minutes < 60) {
        return translate('autosave.minutes-ago', {
            count: minutes,
            defaultValue: 'Last saved {{count}} minute ago',
        });
    }
    return translate('autosave.hours-ago', {
        count: Math.floor(minutes / 60),
        defaultValue: 'Last saved {{count}} hours ago',
    });
};

export default useLastSavedLabel;
